module.exports = __webpack_public_path__ + "static/media/cargo_trailer.b244beaf.svg";